export * from './testing/router_testing_providers';

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
